import phonegap from "./phonegap";
import Display from "./Display";
import Draw from "./Draw";
import Gyro from "./Gyro";
import SimpleCollide from "./SimpleCollide";
import SpineUtils from "./SpineUtils";
import AlphaFilter from "./AlphaFilter";
import Geom from "./Geom";
import ismobilejs from "ismobilejs";
const isMobileLib = ismobilejs(window.navigator);
import Math from "./Math";
import InScreenLoader from "./InScreenLoader";
import SpineEP from "./SpineEP";
import SpinePlayer from "./SpinePlayer";

/**
 *
 * @namespace earthpixi.utils
 * @memberof earthpixi
 *
 */

export default {

    phonegap,
    Display,
    Draw,
    Gyro,
    SimpleCollide,
    /**
    * @memberof earthpixi.utils
    */
    SpineUtils,
    AlphaFilter,
    Geom,
    Math,
    InScreenLoader,
    SpineEP,
    SpinePlayer,

    PhoneGap()
    {
        return phonegap;
    },

    Utils()
    {
        return utils;
    },

    /**
   * Shuffle an array
   *
   * @memberof earthpixi.utils
   *
   *
   * @param array
   * @returns {array}
   */
    shuffleArray(array)
    {
        let currentIndex = array.length; let temporaryValue; let
            randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex !== 0)
        {
            // Pick a remaining element...
            randomIndex = window.Math.floor(window.Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    },

    /**
     * Get Query strings, returns object containing properties or single property
     *
     * @memberof earthpixi.utils
     *
     * @param {string} [search] Return just this property or null
     * @param {string} [match] match this or return null
     * @returns {{} | string | null}
     */
    getQueryStrings(search, match)
    {
        // const hashes = window.top.location.search.slice(window.top.location.search.indexOf("?") + 1).split("&");
        const hashes = window.location.search.slice(window.location.search.indexOf("?") + 1).split("&");

        const props =  hashes.reduce((params, hash) =>
        {
            const [key, val] = hash.split("=");

            return Object.assign(params, { [key]: decodeURIComponent(val) });
        }, {});

        if (search)
        {
            const found = props[search];

            if (!found) return null;

            if (match)
            {
                return found === match;
            }

            return found;
        }

        return props;
    },

    /**
     *
   * Are we on a tablet device?
   *
   * @memberof earthpixi.utils
   * @type boolean
   * @returns {bool}
   */
    get isTablet()
    {
        return (isMobileLib.tablet);
    },

    /**
   * Are we on a tablet device?
   *
   * @memberof earthpixi.utils
   * @type isMobile
   * @returns {isMobile}
   */
    get isMobile()
    {
        return isMobileLib;
    },

    /**
   * Are we on a touchscreen device?
   *
   * @memberof earthpixi.utils
   * @type boolean
   * @returns {boolean}
   */
    get isTouchDevice()
    {
        return (("ontouchstart" in window)
    || (navigator.MaxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0));
    },

    /**
   * Is an item currently on stage
   *
   * @memberof earthpixi.utils
   * @param displayObject
   * @returns {boolean}
   */
    onStage(displayObject)
    {
        let item = displayObject;
        let foundStage = false;

        do
        {
            if (!item.parent)
            {
                return false;
            }

            item = item.parent;
            if (item === earthpixi._stageShell)
            {
                foundStage = true;
            }
        } while (!foundStage);

        return true;
    },

    /**
   * Create a new sprite with same texture
   *
   * @memberof earthpixi.utils
   * @static
   * @param {PIXI.Sprite} sprite - sprite to copy
   */
    DuplicateSprite(sprite)
    {
        const newSprite = new PIXI.Sprite(sprite.texture);

        newSprite.scale.x = sprite.scale.x;
        newSprite.scale.y = sprite.scale.y;

        return newSprite;
    },

    /**
   *
   * Copy string to user clipboard, must come from user pointerUP or select event
   *
   * @memberof earthpixi.utils
   * @param {string} str string to copy
   * @static
   */
    CopyToClipboard(str)
    {
        //console.log(`try copy: ${str}`);

        const ta = document.createElement("textarea"); // Create a <textarea> element

        // create fake text area
        ta.value = str; // Set its value to the string that you want copied
        ta.setAttribute("readonly", true);
        ta.setAttribute("contentEditable", true);
        ta.style.position = "absolute";
        ta.style.left = "-9999px"; // Move outside the screen to make it invisible
        document.body.appendChild(ta); // Append the <textarea> element to the HTML document

        // select text, works for normal browsers
        ta.select();
        document.execCommand("copy");

        // for ios
        const range = document.createRange();
        range.selectNodeContents(ta);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        ta.setSelectionRange(0, 999999);
        document.execCommand("copy");

        // const selected = document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        //     ? document.getSelection().getRangeAt(0) // Store selection if found
        //     : false; // Mark as false to know no selection existed before

        // el.select(); // Select the <textarea> content
        document.body.removeChild(ta); // Remove the <textarea> element
        // if (selected)
        // { // If a selection existed before copying
        //     document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        //     document.getSelection().addRange(selected); // Restore the original selection
        // }
    },

    /**
     *
     * Copy string to user clipboard, must come from user event like a click
     *
     * @memberof earthpixi.utils
     * @param {earpixi.InputField} input string to copy
     * @static
     */
    PasteFromClipboard(inputField)
    {
        // console.log(navigator.permissions);
        //
        // navigator.permissions.query({name:"clipboard-read"}).then(
        //     (state)=>{
        //      console.log(state);
        //     }
        // );
        //
        // return;

        if (navigator.clipboard && navigator.clipboard.readText)
        {
            navigator.clipboard.readText().then(
                (text) =>
                {
                    inputField.text = text;
                },
                (err) =>
                {
                    console.log(err);
                }
            );

            return;
        }

        inputField.activate();
        document.execCommand("paste");

        inputField.updateCaret();

        // return;
        //
        // const el = document.createElement("textarea"); // Create a <textarea> element
        //
        // el.value = ""; // Set its value to the string that you want copied
        // el.setAttribute("contentEditable", ""); // Make it readonly to be tamper-proof
        // el.style.position = "absolute";
        // el.style.left = "-9999px"; // Move outside the screen to make it invisible
        // document.body.appendChild(el); // Append the <textarea> element to the HTML document
        // const selected
        //     = document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        //         ? document.getSelection().getRangeAt(0) // Store selection if found
        //         : false; // Mark as false to know no selection existed before
        //
        // el.select(); // Select the <textarea> content
        // document.execCommand("Paste"); // Copy - only works as a result of a user action (e.g. click events)
        // const pastedVal = el.value;
        //
        // inputField.text = pastedVal;
        // // document.body.removeChild(el); // Remove the <textarea> element
        // if (selected)
        // { // If a selection existed before copying
        //     document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        //     document.getSelection().addRange(selected); // Restore the original selection
        // }
    },

    /*
   * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
   * Author: Jim Palmer (based on chunking idea from Dave Koelle)
   *
   * `myArray.sort(earthpixi.utils.NaturalSort)`
   *
   * @memberof earthpixi.utils
   * @static
   *
   */
    NaturalSort(a, b)
    {
        const re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi;
        const sre = /(^[ ]*|[ ]*$)/g;
        const dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/;
        const hre = /^0x[0-9a-f]+$/i;
        const ore = /^0/;
        const i = function (s)
        {
            return false && (`${s}`).toLowerCase() || `${s}`;
        };
        // convert all to strings strip whitespace
        const x = i(a.name).replace(sre, "") || "";
        const y = i(b.name).replace(sre, "") || "";
        // chunk/tokenize
        const xN = x.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0");
        const yN = y.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0");
        // numeric, hex or date detection
        const xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x));
        const yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null;
        let oFxNcL; let
            oFyNcL;
        // first try and sort Hex codes or Dates

        if (yD)
        {
            if (xD < yD) return -1;
            else if (xD > yD) return 1;
        }
        // natural sorting through split numeric strings and default strings
        for (let cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++)
        {
            // find floats not starting with '0', string or 0 if not defined (Clint Priest)
            oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
            oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
            // handle numeric vs string comparison - number < string - (Kyle Adams)
            if (isNaN(oFxNcL) !== isNaN(oFyNcL))
            {
                return (isNaN(oFxNcL)) ? 1 : -1;
            }
            // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
            else if (typeof oFxNcL !== typeof oFyNcL)
            {
                oFxNcL = String(oFxNcL);
                oFyNcL = String(oFyNcL);
            }
            if (oFxNcL < oFyNcL) return -1;
            if (oFxNcL > oFyNcL) return 1;
        }

        return 0;
    },

    /**
   * @memberof earthpixi.utils
   * @returns {string}
   */
    GetDateString()
    {
        let str = "";

        const date = new Date();

        str += `${date.getDate()} `;
        str += `${earthpixi.utils.GetMonthName(date.getMonth())} `;
        str += date.getFullYear();

        return str;
    },

    /**
   * @memberof earthpixi.utils
   * @param seconds
   * @returns {string}
   */
    GetTimeString(seconds)
    {
        const hours   = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds - (hours * 3600)) / 60);
        let sec = Math.floor(seconds) - Math.floor(hours * 3600) - Math.floor(minutes * 60);

        // if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) { minutes = `0${minutes}`; }
        if (sec < 10) { sec = `0${sec}`; }
        // let time  = hours+':'+minutes+':'+seconds;
        const time  = `${minutes}:${sec} sec`;

        return time;
    },

    /**
   * @memberof earthpixi.utils
   * @param monthNumber
   * @returns {string}
   */
    GetMonthName(monthNumber)
    {
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        return months[monthNumber];
    }

};

